define('models/base/sync-collection-model',['require','underscore','models/base/model','models/base/sync-collection'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Model = require('models/base/model'),
        SyncCollection = require('models/base/sync-collection');

    /*
        Модель с под-коллекциями
    */

    var SyncCollectionModel = Model.extend({
        collectionClass: SyncCollection,
        constructor: function() {
            Model.apply(this, arguments);

            if (_.isFunction(this.collectionClass)) {
                this.classes = {
                    items: this.collectionClass
                };
            } else {
                this.classes = this.collectionClass;
            }

            var classes = this.classes;

            var _this = this;

            _.each(_.keys(classes), function(name) {
                var Class = classes[name];
                _this[name] = new Class();
            });

            this.on('beforeLoad', function() {
                this.eachSubCollection(function(coll) {
                    coll.beginSync();
                });
            });

            this.on('afterLoad', function() {
                this.eachSubCollection(function(coll) {
                    coll.finishSync();
                });
            });
        },
        dispose: function() {
            if (this.disposed) { return; }

            this.eachSubCollection(function(coll) {
                coll.dispose();
            });

            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data) {
            var _this = this;
            this.eachSubCollection(function(coll, name) {
                _this.parseSubCollection(coll, name, data);
            });
            return data;
        },
        parseSubCollection: function(coll, name, data) {
            var input = data[name];
            if (input) {
                coll.reset(input);
            }
        },
        eachSubCollection: function(fn) {
             var _this = this;
            _.each(_.keys(this.classes), function(name) {
                fn(_this[name], name);
            });
        }
    });

    return SyncCollectionModel;
});
